import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'tangram-ai-title-desc-editor',
  templateUrl: './ai-title-desc-editor.component.html',
  styleUrls: ['./ai-title-desc-editor.component.scss'],
})
export class AiTitleDescEditorComponent implements OnChanges {
  @Input() aiTitle: string = '';
  @Input() aiDescription: string = '';
  @Input() isLoading: boolean = false;
  @Input() maxTitleLength: number = 100;
  @Input() maxDescriptionLength: number = 300;

  @Output() applyTitle       = new EventEmitter<string>();
  @Output() applyDescription = new EventEmitter<string>();
  @Output() regenerate       = new EventEmitter<void>();

  editingTitle = false;
  editingDesc  = false;
  editedTitle  = '';
  editedDesc   = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.aiTitle && changes.aiTitle.currentValue) {
      this.editedTitle   = this.clamp(changes.aiTitle.currentValue, this.maxTitleLength);
      this.editingTitle  = false;
    }
    if (changes.aiDescription && changes.aiDescription.currentValue) {
      this.editedDesc   = this.clamp(changes.aiDescription.currentValue, this.maxDescriptionLength);
      this.editingDesc  = false;
    }
  }

  private clamp(value: string, max: number): string {
    const trimmed = (value || '').trim();
    if (trimmed.length <= max) { return trimmed; }
    return trimmed.substring(0, max).trim();
  }

  startEditTitle(): void {
    this.editedTitle  = this.aiTitle;
    this.editingTitle = true;
  }

  startEditDesc(): void {
    this.editedDesc  = this.aiDescription;
    this.editingDesc = true;
  }

  confirmTitle(): void {
    const value = this.clamp(this.editedTitle.trim() || this.aiTitle, this.maxTitleLength);
    this.applyTitle.emit(value);
    this.editingTitle = false;
  }

  confirmDesc(): void {
    const value = this.clamp(this.editedDesc.trim() || this.aiDescription, this.maxDescriptionLength);
    this.applyDescription.emit(value);
    this.editingDesc = false;
  }

  applyTitleToForm(): void {
    this.applyTitle.emit(this.clamp(this.aiTitle, this.maxTitleLength));
  }

  applyDescriptionToForm(): void {
    this.applyDescription.emit(this.clamp(this.aiDescription, this.maxDescriptionLength));
  }

  get hasContent(): boolean {
    return !!(this.aiTitle || this.aiDescription);
  }
}
